const store = new Map<
  string,
  { promise: Promise<unknown>; data?: unknown }
>();

/** Dedupe identical API calls (in-flight + resolved) for the current session. */
export const fetchOnce = async <T>(
  key: string,
  fetcher: () => Promise<T>,
): Promise<T> => {
  const entry = store.get(key);
  if (entry?.data !== undefined) {
    return entry.data as T;
  }
  if (entry?.promise) {
    return entry.promise as Promise<T>;
  }

  const promise = fetcher()
    .then((data) => {
      store.set(key, { promise, data });
      return data;
    })
    .catch((error) => {
      store.delete(key);
      throw error;
    });

  store.set(key, { promise });
  return promise;
};

export const clearFetchOnceCache = () => {
  store.clear();
};
